<template>
    <div class="main">
        <my-nav-bar title="" :bordered="false" background="transparent"/>
        <div class="cover">
            <img :src="detail.img" alt="">
        </div>
        <div class="title">{{ detail.name }}</div>
        <div class="operate">
            <div class="clock" @click="clock">
                <span class="iconfont icon-bell"></span>
                <span class="dingshi">定时</span>
            </div>
            <div class="play" @click="touchPlayBtn">
                <span class="iconfont icon-play" v-if="!play"></span>
                <span class="iconfont icon-pause" v-else></span>
            </div>
            <div class="clock" @click="openAudioList">
                <span class="iconfont icon-cycle"></span>
                <span class="dingshi">换台</span>
            </div>

        </div>
        <div class="list" :style="{'height': height+'px'}" v-if="actList.length>0">
            <div :class="{'item': true,'pass': item.end_time < curTime, 'living': curTime >= item.start_time && curTime <= item.end_time}" v-for="item in actList" :key="item.id">
                <div class="left">
                    <div class="_flex">
                        <span class="audio-title">{{ item.name }}</span>
                        <span class="audio-title" style="font-size:12px;margin-top:5px">{{item.start}}-{{item.end}}</span>
                    </div>
                    <div class="living" v-if="curTime >= item.start_time && curTime <= item.end_time">
                        <img src="@/assets/img/ic_live.gif" alt="">
                        LIVE
                    </div>
                </div>
                <span class="time">{{ item.start }}</span>
            </div>
        </div>
        <div class="empty" v-else>
            <img class="_img" src="@/assets/img/pic_empty.png" alt="">
            <span>暂无节目单</span>
        </div>
        <van-popup v-model="showAudioList" position="bottom" round >
            <div class="popup-body">
                <div class="sub-title">其他电台</div>
                <mescroll-vue class="mescroll" ref="mescroll" :up="mescrollUp">
                    <div class="item" v-for="item in audioList" :key="item.id" @click="changeAudio(item)">
                        <div class="audio-cover">
                            <img :src="item.img" alt="">
                        </div>
                        <div class="info">
                            <span class="name">{{ item.name }}</span>
                            <div class="cur-name">
                                <span class="label">正在直播：</span>
                                {{ item.show_name }}
                            </div>
                            <div class="listens">
                                <span class="iconfont icon-headset"></span>
                                {{ item.views }}
                            </div>
                        </div>
                    </div>
                </mescroll-vue>
<!--                <div id="mescroll">-->
<!--                    <div>-->
<!--                        -->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </van-popup>
        <!--定时关闭-->
        <van-action-sheet
            v-model="showTiming"
            :actions="actions"
            cancel-text="关闭"
            @select="setTiming"
            close-on-click-action
        />
         <g-player :audioType="OTHER_VIDEO" ref="player"/>
    </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import {getOtherAudioListApi, OtherAudioDetailApi, ActiListApi} from "@/request/api"
import {OTHER_VIDEO} from "@/global/constant";
import {AudioInfo} from "@/global/audio";
import {Toast} from "vant";

export default {
    data(){
        return{
            OTHER_VIDEO,
            play: false,
            height: 0,
            showAudioList: false,
            scroll: null,
            mescrollUp: {
                use: true,
                callback: this.onReachBottom,
            },
            showTiming: false,
            actions: [
                {name: '不开启', color: '#FF4C67' },
                {name: "10分钟", times: 60 * 10},
                {name: "20分钟", times: 60 * 20},
                {name: "30分钟", times: 60 * 30},
                {name: "60分钟", times: 60 * 60},
                {name: "90分钟", times: 60 * 90},
            ],
            actList: [],
            filters: {
                page: 1,
                pcount: 10
            },
            audioList: [],
            id: null,
            detail: {},
            audioDetail: {},
            curTime: 0,
            timer: null,
            finished: false,
            isShare:false
        }
    },
    created() {
        this.id = this.$route.query.id || 159
        this.getData()
        this.getOtherList()
        this.setTimer()

        this.checkIsShare()
    },
    mounted() {
        this.setHeight()
    },
    beforeDestory(){
        clearInterval(this.timer)
    },
    components: {MescrollVue},
    methods:{
        checkIsShare(){
            let paramsStr = window.location.href.split("?")[1]
            if(!paramsStr)return
            let data = this.getParams(paramsStr)
            if (data.isShare == 1)this.isShare = true
        },
        getParams(str){
            let obj = {}
            let arr = str.split("&")
            arr.forEach(item=>{
                obj[item.split("=")[0]] = item.split("=")[1]
            })
            return obj
        },
        clock(){
            if(this.isShare==true){
                this.openDownModal()
                return
            }
            this.showTiming = true

        },
        setHeight(){
            this.height = document.body.clientHeight - 430
        },
        setTimer(){
          this.timer = setInterval(()=>{
              this.curTime = Math.floor(new Date().getTime()/1000)
          }, 1000)
        },
        changeAudio(data){
            this.id = data.id;
            this.getData()
            this.showAudioList = false;
        },
        openAudioList(){
            if(this.isShare==true){
                this.openDownModal()
                return
            }
            this.showAudioList = true
        },
        onReachBottom(){
            if (this.finished)return;
            this.filters.page ++
            this.getOtherList()
        },
        setTiming(e){
            let times = e.times
        },
        // 播放音频
        startPlay(){
            this.audioDetail = new AudioInfo(this.detail.id, this.detail.name, this.detail.stream, this.detail.img, OTHER_VIDEO)
            // console.log(this.$refs.player);
            console.log(this.$refs.player)
            let tmp = JSON.parse(JSON.stringify(this.audioDetail))
            this.$refs.player.play(tmp)
            this.play = true
        },
        touchPlayBtn(){
            if(this.play){
                this.$refs.player.stop()
                this.play = false
            }else{
                let tmp = JSON.parse(JSON.stringify(this.audioDetail))
                // 需要重载一次
                this.$refs.player.play(tmp)
                this.play = true
            }
        },
        getData(){
            Toast.loading("加载中")
            OtherAudioDetailApi({id: this.id}).then(res=>{
                this.detail = res.data
                this.globalInitWxShare(this.detail.name, "", this.detail.img)
                this.startPlay()
                Toast.clear()
            })
            ActiListApi({id: this.id}).then(res=>{
                this.actList = res.list.map(item=>{
                    return{
                        ...item,
                        start_time: Math.floor(new Date(item.date + " " + item.start).getTime()/1000)
                    }
                })
                this.actList = this.actList.map((item, index)=>{
                    let next = this.actList[index + 1]
                    return {
                        ...item,
                        end_time: next ? next.start_time : 9999999999
                    }
                })
                console.log(this.actList)
                this.initCurPlayAudio()
            })
        },
        // 当前正在播放的
        initCurPlayAudio(){
            console.log(this.actList)
        },
        getOtherList(){
            getOtherAudioListApi(this.filters).then(res=>{
                if(this.filters.page == 1){
                    this.audioList = res.data
                }else{
                    this.audioList.push(...res.data)
                }
                if(res.data.length < this.filters.pcount){
                    this.mescrollUp.use = false
                    this.finished = true;
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.main{
    width: 100%;
    min-height: 100vh;
    background-color: #F8F8F8;
    display: flex;
    align-items: center;
    flex-direction: column;
    .cover{
        margin-top: 20px;
        width: 220px;
        height: 220px;
        border-radius: 6px;
        overflow: hidden;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .title{
        margin: 12px 0 20px 0;
        font-weight: bold;
    }
    .operate:extend(.flex-btw){
        .clock{
            display: flex;
            flex-direction: column;
            align-items: center;
            .dingshi{
                font-size: 12px;
            }
        }
        .iconfont{
            font-size: 32px;
            color: @base-color;
        }
        .play:extend(.flex-cen){
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin: 0 32px;
            background-color: @base-color;
            .iconfont{
                color: #FFF;
            }
        }
    }
    .list{
        position: fixed;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 343px;
        box-sizing: border-box;
        padding: 20px 16px 0 16px;
        background-color: #fff;
        border-radius: 16px 16px 0 0 ;
        overflow-y: scroll;
        .item:extend(.flex-btw){
            padding-bottom: 20px;
            margin-bottom: 20px;
            border-bottom: 1px solid #EEEEEE;
            font-size: 16px;
            .left:extend(.flex-cen){
                ._flex{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .living{
                    font-size: 12px;
                    margin-right: 4px;
                    padding: 1px 6px;
                    background-color: @base-color;
                    color: #FFF;
                    border-radius: 3px;
                    margin-left: 4px;
                    img{
                        width: 10px;
                        height: 10px;
                    }
                }
            }
        }
        .pass{
            color: #CCCCCC;
        }
        .living{
            .audio-title{
                color: @base-color;
            }
        }
    }
    .empty{
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
            font-size: 14px;
            color: #999;
        }
        ._img{
            width: 200px;
            height: 200px;
        }
    }
    .popup-body{
        width: 100%;
        box-sizing: border-box;
        padding: 8px 16px;
        .sub-title{
            font-weight: bold;
            font-size: 18px;
            margin-bottom: 15px;
        }
        .mescroll{
            height: 45vh;
            .item{
                display: flex;
                margin-bottom: 24px;
                .audio-cover{
                    width: 72px;
                    height: 72px;
                    border-radius: 6px;
                    border: 1px solid #EEEEEE;
                    margin-right: 12px;
                    overflow:hidden;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .info{
                    display: flex;
                    flex-direction: column;
                    .name{
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .cur-name{
                        font-size: 12px;
                        color: #646464;
                        margin: 4px 0;
                        .label{
                            color: @base-color;
                        }
                    }
                    .listens{
                        font-size: 12px;
                        color: #A7A7A7;
                        display: flex;
                        align-items: center;
                        .iconfont{
                            font-size: 16px;
                        }
                    }
                }
            }
            .item:last-child{
                margin-bottom: 0;
            }
        }
    }
}
</style>
